import { h } from "preact";
import { useState } from "preact/hooks";
import { Button, Divider, Form, Input, Select } from "antd";


export default function EditMemberSection(props) {

    const [currentState, setCurrentState] = useState({
        username: props.username, email: props.email, role: props.role
    });

    const onEmailChange = (emailRef) => {
        setCurrentState({ email: emailRef.target.value });
    }

    const onRoleChange = (selectedRole) => {
        setCurrentState({ role: selectedRole });
    }
    const onEditButtonClick = (event) => {
        props.onEdit.call(this, props.username, currentState.email, currentState.role);
    }

    const isUsernameFieldEmpty = currentState.username?.length === 0;
    const isEmailFieldEmpty = currentState.email?.length === 0;
    const disabledState = props.disabled || isUsernameFieldEmpty || isEmailFieldEmpty;
    
    return (
        <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 14 }}
            layout="vertical"
        >
            <Input.Group size="large">
                <Form.Item label={"Username"}>
                    <Input
                        disabled={true}
                        value={props.username}
                        type="text"
                    />
                </Form.Item>
                <Form.Item label={"Email"}>
                    <Input
                        defaultValue={props.email}
                        onChange={onEmailChange}
                        type="text"
                    />
                </Form.Item>
                <Form.Item label={"Role"}>
                    <Select
                        defaultValue={props.role}
                        onChange={onRoleChange}
                    >
                        <Select.Option disabled={true} value={"admin"}>
                            Admin
                        </Select.Option>
                        <Select.Option value={"developer"}>
                            Developer
                        </Select.Option>
                        <Select.Option value={"reporter"}>
                            Reporter
                        </Select.Option>
                    </Select>
                </Form.Item>
                <Divider />
                <Form.Item>
                    <Button
                        onClick={onEditButtonClick}
                        disabled={disabledState}
                        type="primary"
                        size="large"
                    >
                        Save
                    </Button>
                </Form.Item>
            </Input.Group>
        </Form>
    );
}